import { PermissionDefinition } from './permission.types';

/**
 * Master permission catalog keyed by `PermissionKey`.
 * It ties each semantic action to a scope and default allowed roles.
 */
export const PERMISSIONS = {

    /* -------------------------------------------------------------------------- */
    /*                                   Project                                  */
    /* -------------------------------------------------------------------------- */

    'Project.Create': {
        scope: 'project',
        defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
        description: 'Create projects'
    },
    'Project.Edit': {
        scope: 'project',
        defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
        description: 'Edit any project'
    },

    /* -------------------------------------------------------------------------- */
    /*                              SEO Opportunities                             */
    /* -------------------------------------------------------------------------- */

    'Opportunities.View': {
        scope: 'project',
        defaultAllowedRoles: ['Owner', 'Admin', 'Member', 'Viewer'],
        description: 'View SEO opportunities workspace'
    },
    'Opportunities.Edit': {
        scope: 'project',
        defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
        description: 'Edit opportunity status, assignee, and due date'
    },
    'Opportunities.Refresh': {
        scope: 'project',
        defaultAllowedRoles: ['Owner', 'Admin'],
        description: 'Trigger a manual SEO opportunity analysis refresh'
    },

    /* -------------------------------------------------------------------------- */
    /*                                Business Card                               */
    /* -------------------------------------------------------------------------- */

    // 'Card.Manage': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage digital business cards'
    // },
    // 'Card.Analytics.View': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View digital business card analytics'
    // },

    // // Card CRUD
    // 'Card.Cards.Create': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Create card'
    // },
    // 'Card.Cards.Edit': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Edit card'
    // },
    // 'Card.Cards.Delete': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Delete card'
    // },
    // 'Card.Cards.Order': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Order NFC card'
    // },

    // // Contacts
    // 'Card.Contacts.View': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View contacts'
    // },
    // 'Card.Contacts.Export': {
    //     scope: 'card',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Export contacts'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                              Organization Core                             */
    // /* -------------------------------------------------------------------------- */

    // 'Org.General.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View General Organization'
    // },
    // 'Org.General.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage General Organization'
    // },
    // 'Org.Settings.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage organization settings'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                Members & Roles                             */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Members.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Members'
    // },
    // 'Org.Members.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Invite and manage members'
    // },
    // 'Org.Admin.Invite': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Invite teammates to an Organization'
    // },
    // 'Org.Roles.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Roles'
    // },
    // 'Org.Roles.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage Organization Roles'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                 Projects                                   */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Projects.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Projects'
    // },
    // 'Org.Projects.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage Organization Projects'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                Billing & Subscription                      */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Billing.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Billing'
    // },
    // 'Org.Billing.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage Organization Billing'
    // },
    // 'Org.Billing.ManagePlan': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Manage billing and seats'
    // },
    // 'Org.Billing.Access': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Billing Overview'
    // },
    // 'Org.Subscription.Remove': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Add / Remove Features'
    // },
    // 'Org.Subscription.Cancel': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Delete Account / Cancel Subscription'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                             Business Card (Org)                            */
    // /* -------------------------------------------------------------------------- */

    // 'Org.BusinessCard.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Business Cards'
    // },
    // 'Org.BusinessCard.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage Organization Business Cards'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                 Audit & Logs                               */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Audit.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View organization audit log'
    // },
    // 'Org.AuditLog.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Audit Log'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                  Danger Zone                               */
    // /* -------------------------------------------------------------------------- */

    // 'Org.DangerZone.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'View Organization Danger Zone'
    // },
    // 'Org.DangerZone.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Manage Organization Danger Zone'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                               User Account                                 */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Profile.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member', 'Viewer'],
    //     description: 'View Profile'
    // },
    // 'Org.UserAccount.UpdatePassword': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member', 'Viewer'],
    //     description: 'Update User Password'
    // },
    // 'Org.UserAccount.UpdatePaymentMethod': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner'],
    //     description: 'Update Payment Method'
    // },
    // 'Org.UserAccount.Delete': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Delete User Account'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                              SEO & Marketing Tools                         */
    // /* -------------------------------------------------------------------------- */

    // 'Org.BrandMonitoring.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Manage Brand Monitoring'
    // },
    // 'Org.GmbAudit.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View GMB Audit'
    // },
    // 'Org.KeywordResearch.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Manage Keyword Research'
    // },
    // 'Org.KeywordResearch.Export': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Export Keyword Research'
    // },
    // 'Org.KeywordList.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View Keyword Research'
    // },
    // 'Org.KeywordList.Manage': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Manage Keyword List'
    // },
    // 'Org.RankTracking.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View Rank Tracking'
    // },
    // 'Org.Reviews.View': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View Reviews'
    // },

    // /* -------------------------------------------------------------------------- */
    // /*                                  Chatbot                                   */
    // /* -------------------------------------------------------------------------- */

    // 'Org.Chatbot.Create': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Create Chatbot Settings'
    // },
    // 'Org.Chatbot.Edit': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'Edit Chatbot Settings'
    // },
    // 'Org.Chatbot.Delete': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin'],
    //     description: 'Delete Chatbot Settings'
    // },
    // 'Org.Chatbot.ViewForms': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View Forms Chatbot Settings'
    // },
    // 'Org.Chatbot.ViewThreads': {
    //     scope: 'org',
    //     defaultAllowedRoles: ['Owner', 'Admin', 'Member'],
    //     description: 'View Threads Chatbot Settings'
    // },

} as const satisfies Record<string, PermissionDefinition>;
